import React from 'react'
import Chip from '@mui/material/Chip'
import { Badge } from '@mui/material'

interface CounterProps {
  itemStatus: string
  statusCount: number
}
export const EmailSendingStatusChip: React.FC<CounterProps> = ({ itemStatus, statusCount }: CounterProps) => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (itemStatus === 'FAILED') {
    color = 'error'
    variant = 'outlined'
  } else if (itemStatus === 'DELIVERED') {
    color = 'primary'
    variant = 'outlined'
  } else if (itemStatus === 'COMPOSED') {
    color = 'secondary'
    variant = 'outlined'
  } else if (itemStatus === 'PENDING') {
    color = 'success'
    variant = 'outlined'
  }

  return (
    <Badge badgeContent={statusCount} color={color} max={9999} anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right'
    }} >
      <Chip label={itemStatus} variant={variant} color={color} />
    </Badge>
  )
}

export default EmailSendingStatusChip
